import React from "react";
import "./TermsAndCondition.scss";
import { useSelector, useDispatch } from 'react-redux';
import Layout from "../../components/layout/Layout";
import ContectInfo from '../../components/home/ContectInfo';
import { useQuery } from "react-query";
import { getlanguageAPI } from "../../services/api";
import { setLanguageIntial } from "../../store/language.slice";

function TermsAndCondition() {
  const dispatch = useDispatch()
  const lnFromStore = useSelector(state=>state.language);
  const language = "en"

  let {isLoading}= useQuery(['policyTerms',language],getlanguageAPI.bind(null,language,"policyTerms"),{
          enabled:!lnFromStore[language],
          onSuccess: o => dispatch(setLanguageIntial({k:language,v:o}))
      });

  const { myAccount: account} = useSelector((state) => state.language?.activelang);
  const policyTerms = useSelector(state => state.language?.activelang?.policyTerms);
  const termsAndConditions = !!policyTerms?.termsAndConditions
  ? JSON.parse(policyTerms.termsAndConditions)
  : {}; 

  return (
    <Layout>
      {isLoading ? (
        <div className="full-window-loading payment-loading">
          <i style={{color:"var(--white)"}}className="pi pi-spin pi-spinner"></i>
          <h2 style={{color:"var(--white)"}}>{account.ACTN0037}</h2>
      </div>
      ) : (
      <section className="about-blocks-section tc-block">
        <div className="terms-and-conditions-section">
          <h1>{termsAndConditions.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: termsAndConditions.description }}></div>
        </div>
      </section >
      )}

      {/*** ContactInfo Section ***/}
      <ContectInfo/>

    </Layout>
  );
}

export default TermsAndCondition;
